// Languages of the site. The first one is served without a prefix (/), the others under /en/, /ru/…
// Adding a language: add its code here, then a block for it in every translation file.
export const LANGS = ["fr", "en", "de", "es", "it", "ru"];
export const DEFAULT_LANG = LANGS[0];
// Shown when a language has no articles of its own yet.
export const FALLBACK_LANG = "en";
export const SITE = "https://www.davoyage.com";

export const langPrefix = (lang) => (lang === DEFAULT_LANG ? "" : "/" + lang);

const prefixPattern = new RegExp("^/(" + LANGS.filter((l) => l !== DEFAULT_LANG).join("|") + ")(?=/|$)");

// The same page in another language: every page except articles has the same path in each language,
// only the prefix changes. Articles pass their translated slugs as alternates; until they load,
// we fall back to the blog. The Stripe parameters are dropped on the success page, so switching
// language does not count the payment twice.
export const languageLink = (lang, { pathname, search = "" }, alternates) => {
  if (alternates && alternates[lang]) return alternates[lang];
  let path = pathname.replace(prefixPattern, "") || "/";
  if (/^\/blog\/[^/]+/.test(path)) path = "/blog/";
  if (/\/success\/?$/.test(path)) search = "";
  return langPrefix(lang) + path + search;
};
